export enum QuoteSize {
    small = 'small',
    large = 'large',
}
